// extracted by mini-css-extract-plugin
export default {"container":"Sl-z","blurb":"Tl-z","links":"Ul-z"};